import script from "./CertificationApplyModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificationApplyModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__